//import PlusBtn from './../../assets/appIcons/BTN_Plus.svg';
import { blueyetiStates } from './../../utils/blueyetiStates'
import store from '../Lightbox/LightboxStore'
import { sync } from 'vuex-pathify'
import axios from 'axios'
import VueTimers from 'vue-timers';
import '@/utils/pretty-checkbox/pretty-checkbox.scss';
import TrashBtn from './../../assets/appIcons/BTN_Trash.svg';
import StarBtn from './../../assets/appIcons/BTN_Star.svg';


export default {
   name: 'gallery-item',
   components: {TrashBtn, StarBtn },
   mixins: [blueyetiStates],
   props: {
      thumb: {
         type: String,
         default: ''
      },
      message: {
         type: Object,
         default: {}
      },
      type: {
         type: String,
         default: 'image'
      },
      buttoncolor: {
         type: String,
         default: 'white'
      },

   },
   data () {
      return {
         deleteMessage: false,
         deleteCheck: false,
         starCheck: false,
         showDeleteFirstMessBtn: false

      }
   },
   created() {
      //console.log(this.message);
      this.$eventHub.$on('reset', (e) => {
         this.destroyMethod();
      });
      if(this.type != 'button') {
         this.starCheck = this.message.stared;
      }
   },
   timers: {
      TrashBtnTimer: { time: 8000, autostart: false },
   },
   computed: {
      is_dev_mode:sync('is_dev_mode'),
      is_idle:sync('is_idle'),
      host_address:sync('host_address'),
      messageId: sync('messageId'),
      api_address:sync('api_address'),
      token:sync('token'),
      updateButton: function () {

         if(this.type == 'button') {
            //this.$refs.plusButtonSVG.setCurrentTime(0);
            //this.$refs.plusButtonSVG.unpauseAnimations();
            // `this` pointe sur l'instance vm
            //console.log('button computed ' + this.$refs.plusButtonSVG);
         }
      }
   },
   mounted () {
      //console.log('thumb ' + this.thumb);
      //console.log('file ' + this.file);
      if(this.type != 'button') {

      if(this.messageId == this.message.id) {
         this.showDeleteFirstMessBtn = true;
         this.$timer.start("TrashBtnTimer");

         // this.$refs.plusButtonSVG.setCurrentTime(0);
         // this.$refs.plusButtonSVG.unpauseAnimations();
         // `this` pointe sur l'instance vm
         //console.log('button ' + this.buttoncolor);
      }
   }
   },
   watch: {
      deleteMessage: function(id) {
         console.log("delete last message " + this.messageId);
         //console.log(this.message);
         this.deleteCheck = true;
         this.updateMessage();
      },
      deleteCheck: function(id) {
         this.updateMessage();
      },
      starCheck: function(id) {
         this.updateMessage();
      },
   },
   methods: {
      gotoShooting: function(e){
         this.byst_SetState('shooting/loading');
      },
      updateMessage: function() {
         if(this.byst_CompareCurrentStates(['gallery/admin/idle']) || this.deleteMessage)
         {
            const that = this;

            axios.post( this.api_address + 'message', {
               token:that.token,
               id: that.message.id,
               deleted: that.deleteCheck,
               stared: that.starCheck,
            })
            .then(function (response) {
               console.log("response " + response.data);
               // console.log(response);
               // console.log(response.data);
               // console.log(JSON.parse(response.data).id);
               if(that.deleteMessage)
                  location.reload(true);
            })
            .catch(function (error) {
               console.log(error);
            });

         }

      },
      TrashBtnTimer: function () {
         this.showDeleteFirstMessBtn = false;
      },
      destroyMethod: function () {
         //this.$eventHub.$off('reset');
         //console.log("destroy")
      },

   }
}
